/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  GET_ORG_DETAILS: "GET_ORG_DETAILS",
  GET_ORG_DETAILS_SUCCESS: "GET_ORG_DETAILS_SUCCESS",
  GET_ORG_DETAILS_FAILURE: "GET_ORG_DETAILS_FAILURE",
  GET_ORG_DETAILS_LOADER: "GET_ORG_DETAILS_LOADER",

  GET_OVERVIEW_DATA: "GET_OVERVIEW_DATA",
  GET_OVERVIEW_DATA_LOADER: "GET_OVERVIEW_DATA_LOADER",
  GET_OVERVIEW_DATA_SUCCESS: "GET_OVERVIEW_DATA_SUCCESS",
  GET_OVERVIEW_DATA_FAILURE: "GET_OVERVIEW_DATA_FAILURE",

  GET_TAB_LIST_DATA: "GET_TAB_LIST_DATA",
  GET_TAB_LIST_DATA_SUCCESS: "GET_TAB_LIST_DATA_SUCCESS",
  GET_TAB_LIST_DATA_FAILURE: "GET_TAB_LIST_DATA_FAILURE",
  GET_TAB_LIST_LOADER: "GET_TAB_LIST_LOADER",

  GET_DYNAMIC_COURSE_LIST: "GET_DYNAMIC_COURSE_LIST",
  GET_DYNAMIC_COURSE_LIST_SUCCESS: "GET_DYNAMIC_COURSE_LIST_SUCCESS",
  GET_DYNAMIC_COURSE_LIST_FAILURE: "GET_DYNAMIC_COURSE_LIST_FAILURE",

  GET_DYNAMIC_COURSE_PRICE: "GET_DYNAMIC_COURSE_PRICE",
  GET_DYNAMIC_COURSE_PRICE_SUCCESS: "GET_DYNAMIC_COURSE_PRICE_SUCCESS",
  GET_DYNAMIC_COURSE_PRICE_FAILURE: "GET_DYNAMIC_COURSE_PRICE_FAILURE",

  SET_DYNAMIC_BUNDLING_SELECTED: "SET_DYNAMIC_BUNDLING_SELECTED",
  SET_DYNAMIC_BUNDLING_BTN_LOADER: "SET_DYNAMIC_BUNDLING_BTN_LOADER",
  UPDATE_PHYSICAL_DELIVERY_ENABLED: "UPDATE_PHYSICAL_DELIVERY_ENABLED",

  GET_COURSES_LIST_DATA: "GET_COURSES_LIST_DATA",
  GET_COURSES_LIST_DATA_SUCCESS: "GET_COURSES_LIST_DATA_SUCCESS",
  GET_COURSES_LIST_DATA_FAILURE: "GET_COURSES_LIST_DATA_FAILURE",

  GET_COURSE_PRICE: "GET_COURSE_PRICE",
  GET_COURSE_PRICE_SUCCESS: "GET_COURSE_PRICE_SUCCESS",
  GET_COURSE_PRICE_FAILURE: "GET_COURSE_PRICE_FAILURE",
  GET_COURSE_PRICE_LOADER: "GET_COURSE_PRICE_LOADER",

  POST_LIKE_COURSE: "POST_LIKE_COURSE",
  POST_LIKE_COURSE_SUCCESS: "POST_LIKE_COURSE_SUCCESS",
  POST_LIKE_COURSE_ERROR: "POST_LIKE_COURSE_ERROR",
  POST_LIKE_COURSE_RESET: "POST_LIKE_COURSE_RESET",

  GET_USER_DETAILS: "GET_USER_DETAILS",
  GET_USER_DETAILS_SUCCESS: "GET_USER_DETAILS_SUCCESS",
  GET_USER_DETAILS_ERROR: "GET_USER_DETAILS_ERROR",
  GET_USER_DETAILS_LOADING: "GET_USER_DETAILS_LOADING",
  SET_OVERVIEW_DATA_DIRECTLY_IN_STORE: "SET_OVERVIEW_DATA_DIRECTLY_IN_STORE",

  GET_ORG_DETAILS: "GET_ORG_DETAILS",
  GET_ORG_DETAILS_SUCCESS: "GET_ORG_DETAILS_SUCCESS",
  GET_COURSE_PRICE_FAILURE: "GET_COURSE_PRICE_FAILURE",

  GET_INDIVIDUAL_INSTALLMENT: "GET_INDIVIDUAL_INSTALLMENT",
  GET_INDIVIDUAL_INSTALLMENT_SUCCESS: "GET_INDIVIDUAL_INSTALLMENT_SUCCESS",
  GET_INDIVIDUAL_INSTALLMENT_FAILURE: "GET_INDIVIDUAL_INSTALLMENT_FAILURE",
  GET_INDIVIDUAL_INSTALLMENT_LOADER: "GET_INDIVIDUAL_INSTALLMENT_LOADER",

  //GET GRAPH COURSE PRICE
  GET_GRAPH_COURSE_PRICE_DETAILS: "GET_GRAPH_COURSE_PRICE_DETAILS",
  GET_GRAPH_COURSE_PRICE_DETAILS_LOADER: `GET_GRAPH_COURSE_PRICE_DETAILS_LOADER`,
  GET_GRAPH_COURSE_PRICE_DETAILS_SUCCESS: `GET_GRAPH_COURSE_PRICE_DETAILS_SUCCESS`,
  GET_GRAPH_COURSE_PRICE_DETAILS_FAILURE: `GET_GRAPH_COURSE_PRICE_DETAILS_FAILURE`,

  //GET GRAPH COUPONS LIST
  GET_GRAPH_COUPONS_LIST: "GET_GRAPH_COUPONS_LIST",
  GET_GRAPH_COUPONS_LIST_LOADER: `GET_GRAPH_COUPONS_LIST_LOADER`,
  GET_GRAPH_COUPONS_LIST_SUCCESS: `GET_GRAPH_COUPONS_LIST_SUCCESS`,
  GET_GRAPH_COUPONS_LIST_FAILURE: `GET_GRAPH_COUPONS_LIST_FAILURE`,

  //APPLY GRAPH COUPON
  APPLY_COURSE_COUPON: "APPLY_COURSE_COUPON",
  APPLY_COURSE_COUPON_LOADER: `APPLY_COURSE_COUPON_LOADER`,
  APPLY_COURSE_COUPON_SUCCESS: `APPLY_COURSE_COUPON_SUCCESS`,
  APPLY_COURSE_COUPON_FAILURE: `APPLY_COURSE_COUPON_FAILURE`,

  //REMOVE GRAPH COUPON
  REMOVE_COURSE_COUPON: "REMOVE_COURSE_COUPON",
  REMOVE_COURSE_COUPON_LOADER: `REMOVE_COURSE_COUPON_LOADER`,
  REMOVE_COURSE_COUPON_SUCCESS: `REMOVE_COURSE_COUPON_SUCCESS`,
  REMOVE_COURSE_COUPON_FAILURE: `REMOVE_COURSE_COUPON_FAILURE`,

  //SHOW FAKE LOADING
  APPLY_COUPON_FAKE_LOADING: "APPLY_COUPON_FAKE_LOADING",

  TIGHT_BUDGET_BOTTOMSHEET_CLOSE: "TIGHT_BUDGET_BOTTOMSHEET_CLOSE",
  SET_SELECTED_STATE: "SET_SELECTED_STATE",

  //APPLY_COUPON
  APPLY_COUPON_SUCCESS_POPUP: "APPLY_COUPON_SUCCESS_POPUP",
  FUNNEL_TRACKING: "FUNNEL_TRACKING",
  FUNNEL_TRACKING_HISTORY_OBJECT: "FUNNEL_TRACKING_HISTORY_OBJECT",
  SET_CURRENT_COUPON_CODE: "SET_CURRENT_COUPON_CODE",

  // LIKE COURSE
  UPDATE_COURSE_LIKE_COUNT: `UPDATE_COURSE_LIKE_COUNT`,
  IS_INSTALLMENT_PAYMENT: `IS_INSTALLMENT_PAYMENT`,
  // set upcoming live class
  SET_UPCOMING_LIVE_CLASS: `SET_UPCOMING_LIVE_CLASS`,

  // To show shimmer on force refresh
  SET_FORCEFUL_SHIMMER: `SET_FORCEFUL_SHIMMER`,

  SET_PREV_ORDER_ID: `SET_PREV_ORDER_ID`,

  // Payment failed case : when we are showing option to select qr or normal flow on retry click
  SET_RETRYING_PAYMENT: `SET_RETRYING_PAYMENT`,

  // SELECTED VALIDIDTY
  SET_VALIDITY: `SET_VALIDITY`,

  // SHOW COUPON MODAL
  SHOW_COUPON_MODAL: `SHOW_COUPON_MODAL`,

  SET_PAYMENT_OPTIONS: "SET_PAYMENT_OPTIONS",
  GET_COURSE_FACULTY_LIST: "GET_COURSE_FACULTY_LIST",
  SAVE_COURSE_FACULTY_LIST: "SAVE_COURSE_FACULTY_LIST",
  CAPTURE_INTEREST: "CAPTURE_INTEREST",
  BUY_NOW_SUCCESS_MODAL: "BUY_NOW_SUCCESS_MODAL",
  WHATSAPP_PAYMENT_LOADING: "WHATSAPP_PAYMENT_LOADING",

  // COMBO COURSES
  SET_COMBO_COURSE_LIST: "SET_COMBO_COURSE_LIST",
  SET_COMBO_COURSE_ID: "SET_COMBO_COURSE_ID",
  
  SET_STANDALONE_URL: "SET_STANDALONE_URL",
  MONEY_BACK_GUARANTEE: 'MONEY_BACK_GUARANTEE',
  MONEY_BACK_GUARANTEE_PRICE: 'MONEY_BACK_GUARANTEE_PRICE',
};
// export const installmentsEnum = {
//   0: "UNPAID",
//   1: "PENDING",
//   2: "DUE",
//   3: "PAID",
// };
export const installmentsAlertStateEnum = {
  NO_ALERT: 0,
  DAYS_LEFT_EXPIRE: 1,
  COURSE_LOCKED: 2,
  TIGHT_BUDGET: 3,
};
export const trackIDMap = {
  appLaunch: 1,
  cardClick: 2,
  storeOverview: 3, //done
  courseOverview: 4, //done
  contentList: 5, //done
  contentView: 6, //done
  buyNow: 7, //done
  verifyOTP: 8, //done
  addToCart: 9, //done
  paymentFailed: 10, //done
  subscribeCourse: 11, //done
  courseList: 12,
  buyNowPage: 13,
};
